import Vue from "vue";
import Vuex from "vuex";

import auth from "./modules/auth.store";
import loader from "./modules/loader.store";
import signup from "./modules/signup.store";
import scope from "./modules/scope.store";
import timesheets from "./modules/timesheets.store";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    loader,
    signup,
    scope,
    timesheets
  }
})
